var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { GalaxyApi } from "@/api";
import { rethrowSimple } from "@/utils/simple-error";
export function getSelectableObjectStores() {
    return __awaiter(this, void 0, void 0, function* () {
        const { data, error } = yield GalaxyApi().GET("/api/object_stores", {
            params: {
                query: { selectable: true },
            },
        });
        if (error) {
            rethrowSimple(error);
        }
        return data;
    });
}
export function getObjectStoreDetails(id) {
    return __awaiter(this, void 0, void 0, function* () {
        if (id.startsWith("user_objects://")) {
            const userObjectStoreId = id.substring("user_objects://".length);
            const { data, error } = yield GalaxyApi().GET("/api/object_store_instances/{uuid}", {
                params: { path: { uuid: userObjectStoreId } },
            });
            if (error) {
                rethrowSimple(error);
            }
            return data;
        }
        else {
            const { data, error } = yield GalaxyApi().GET("/api/object_stores/{object_store_id}", {
                params: { path: { object_store_id: id } },
            });
            if (error) {
                rethrowSimple(error);
            }
            return data;
        }
    });
}
export function updateObjectStore(datasetId, objectStoreId) {
    return __awaiter(this, void 0, void 0, function* () {
        const { error } = yield GalaxyApi().PUT("/api/datasets/{dataset_id}/object_store_id", {
            params: { path: { dataset_id: datasetId } },
            body: { object_store_id: objectStoreId },
        });
        if (error) {
            rethrowSimple(error);
        }
    });
}
